import { ClientRecipientsRowActions, ClientsRowActions } from 'modules/crm/clients/components/ClientsRowActions';
import { CellAlign, CellType, HeadCell } from '@dfl/mui-admin-layout';
import { IClients } from 'modules/crm/clients/interfaces';
import { createdATColumn, emailColumn, phoneColumn } from 'modules/common/constants/common.columns';
import { CLIENTS_PERMISSIONS } from 'modules/crm/clients/constants/clients.permissions';
import { RolesUserCell } from 'modules/security/users/components/RolesCell';
import { userFullNameColumn, userStatusColumn } from 'modules/security/users/constants/user.columns';
import { orderGatewayColumn, orderInvoiceTotal, orderLocationColumn, orderPaymentDateColumn, orderPaymentMethodColumn, orderReadOnlyStatusColumn, orderSubOrderColumn, orderTotalProductColumns } from 'modules/sales/common/constants/order-columns';
import { IOrder } from 'modules/sales/common/interfaces/IOrder';
import { ORDER_PERMISSIONS } from 'modules/sales/common/constants/order-permissions';
import { OrderCodeCell } from 'modules/sales/common/components/OrderCodeCell';
import { Typography } from '@mui/material';
import { getCountryByCode } from 'utils/location';
import { IAddress } from 'lib/dfl-address-form-mui/interfaces';

export const clientRolesColumn: HeadCell = {
  field: 'security.roles',
  sortable: false,
  headerName: 'clients:roles',
  disablePadding: true,
  renderCell: (roles: any) => <RolesUserCell roles={roles}></RolesUserCell>,
};

export const clientsActionsColumn: HeadCell<IClients> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: CLIENTS_PERMISSIONS.CLIENTS_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: ClientsRowActions,
};
export const clientsRecipientsActionsColumn: HeadCell<IClients> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: CLIENTS_PERMISSIONS.CLIENTS_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: ClientRecipientsRowActions,
};

export const clientsOrdersColumn: HeadCell<IClients> = {
  field: 'demographics.orders',
  headerName: 'breadcrumb:orders',
  type: CellType.NUMBER,
  align: CellAlign.CENTER
};

export const clientsLastPurchaseDateColumn: HeadCell<IClients> = {
  field: 'demographics.lastPurchaseDate',
  headerName: 'clients:lastPurchaseDate',
  type: CellType.DATE,
};

export const orderCodeColumn: HeadCell<IOrder> = {
  field: 'code',
  sortable: false,
  headerName: 'order:code',
  disablePadding: false,
  permissions: [ORDER_PERMISSIONS.ORDER_VIEW],
  renderCell: (code: string, data: IOrder) => {
    const orderType = data?.payment?.paid ? 'orders' : 'pre-orders';
    return (
      <OrderCodeCell
        link={`/sales/${orderType}/${data?._id as string}/general`}
        value={code}
        record={data}
      />
    )
  }
};

export const addressColumn: HeadCell<any> = {
  field: 'demographics.addresses',
  translate: true,
  headerName: 'common:countries',
  renderCell: (name: string, data: any) => (
    <Typography>
      {data?.demographics.addresses?.map((address: IAddress) => getCountryByCode(address?.country)).join(', ')}
    </Typography>
  ),
};

export const clientsColumns: Array<HeadCell<any>> = [
  userFullNameColumn('/crm/clients'),
  emailColumn,
  phoneColumn,
  clientsOrdersColumn,
  addressColumn,
  userStatusColumn,
  clientsLastPurchaseDateColumn,
  createdATColumn,
  clientsActionsColumn,
];

export const clientOrderColumns: Array<HeadCell<any>> = [
  orderCodeColumn,
  orderLocationColumn,
  orderReadOnlyStatusColumn,
  orderTotalProductColumns,
  orderInvoiceTotal,
  orderGatewayColumn,
  orderPaymentMethodColumn,
  orderSubOrderColumn,
  orderPaymentDateColumn,
];
